import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Property } from "@stratify/shared";

export interface PropertiesState {
  properties: Property[];
  loading: boolean;
  error: string | null;
  filters: {
    search: string;
    neighbourhood: string;
    suburb: string;
    city: string;
    sortBy: string;
    sortOrder: "asc" | "desc";
  };
  documentListUi: {
    sortBy: string;
    sortOrder: "asc" | "desc";
  };
}

const initialState: PropertiesState = {
  properties: [],
  loading: false,
  error: null,
  filters: {
    search: "",
    neighbourhood: "",
    suburb: "",
    city: "",
    sortBy: "address",
    sortOrder: "asc",
  },
  documentListUi: {
    sortBy: "createdAt",
    sortOrder: "desc",
  },
};

export const propertiesSlice = createSlice({
  name: "properties",
  initialState,
  reducers: {
    startPropertySubscription: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPropertiesSuccess: (state, action: PayloadAction<Property[]>) => {
      state.loading = false;
      state.properties = action.payload;
      state.error = null;
    },
    fetchPropertiesError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setPropertiesFilters: (
      state,
      action: PayloadAction<Partial<PropertiesState["filters"]>>
    ) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPropertyDocumentSort: (
      state,
      action: PayloadAction<{
        sortBy?: string;
        sortOrder?: "asc" | "desc";
      }>
    ) => {
      state.documentListUi = {
        ...state.documentListUi,
        ...action.payload,
      };
    },
  },
});

export const {
  startPropertySubscription,
  fetchPropertiesSuccess,
  fetchPropertiesError,
  setPropertiesFilters,
  setPropertyDocumentSort,
} = propertiesSlice.actions;

export default propertiesSlice.reducer;
